import React from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import PageTransition from '@/components/PageTransition';
import EventGalleryPageContent from '@/app/gallery/components/EventGalleryPageContent';

export default function GalleryPage() {
    return (
        <main className="min-h-screen bg-background">
            <Header />
            <PageTransition>
                <EventGalleryPageContent />
                <Footer />
            </PageTransition>
        </main>
    );
}
